import styled from "styled-components";

export const ProtocolHeaderMainDiv = styled.div`
  margin: 10px 0 0;
  width: 100%;
  display: flex;
  @media (max-width: 910px) {
    display: none;
  }
`;
export const ProtocolHeaderDiv = styled.div`
  margin: 0 auto;
  width: 100%;
  max-width: 860px;
  display: flex;
  align-items: flex-end;
  position: relative;
`;
export const ProtocolTitle = styled.p`
  padding: ${({ padding }) => padding && padding};
  width: ${({ width }) => width && width};
  font-size: 14px;
  font-weight: 600;
  color: #808080;
  text-align: ${({ textAlignCenter }) => textAlignCenter && "center"};
`;
export const DaysDiv = styled.div`
  padding-left: 30px;
  width: 230px;
  display: flex;
  align-items: center;
  justify-content: space-around;
`;
export const DaysText = styled.p`
  width: 23px;
  font-size: 14px;
  font-weight: 600;
  color: #808080;
  text-align: center;
`;
export const PlatformFilter = styled.button`
  font-size: 14px;
  font-weight: 600;
  color: #808080;
  border: none;
  background: transparent;
  position: absolute;
  right: -110px;
  cursor: pointer;
`;
